import React from 'react'
import { NavLink } from 'react-router-dom';
import "tailwindcss/tailwind.css";
import { FindProspectURL } from '../Functions/AIFunctions/FindProspect';

const SearchForProspect =({
    setShowSearching, 
    setProfile,
    auth,
    fbProfile,
    setFoundInts,
    setInterests,
    setDocId,
    setContentGen,
    setError,
    url,
    setURL,
    setEmail,
    setOpenSlide,
    openSlide
}) => {

    const handleSearch = () =>{
        setShowSearching(true)
        setError('')
        setProfile('')
        //insert function here to search for prospect and spit it back out so we can set profile and interests and all that jazz
        FindProspectURL(
            url,
            setShowSearching, 
            setProfile,
            auth,
            fbProfile,
            setFoundInts,
            setInterests,
            setDocId,
            setContentGen,
            setError,
            setEmail
        )
    }

    return (
        <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6 flex">
                <input
                    type="text"
                    name="text"
                    id="text"
                    className="shadow-sm p-2 focus:outline-none focus:ring focus:border-indigo-300 block w-1/2 sm:text-sm border-blue-300 border-2 rounded-md"
                    placeholder="Linkedin URL"
                    onChange={(e) => setURL(e.target.value)}
                />
                <button 
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-4 focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50"
                    onClick={() => handleSearch()}
                    disabled={url === '' ? true : false}
                >
                    Search For Prospect
                </button>
                <NavLink
                exact
                to='/importContacts'
                style ={{textDecoration:'none'}}
                >
                <button
                    className="bg-gray-700 border-2 border-gray-700 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded ml-4 focus:outline-none disabled:opacity-50"
                >
                    + Bulk Search Prospects
                </button>
                </NavLink>
                {/* <button 
                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ml-4 focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50"
                    onClick={() => setOpenSlide(!openSlide)}
                >
                    Prospected
                </button> */}
            </div>
        </div>
    )
}

export default SearchForProspect
